import { Link } from "react-router-dom";
import { Github, Twitter, Linkedin, Youtube, MessageCircle, Mail } from "lucide-react";
import Logo from "@/components/common/Logo";
import { BRAND, activeSocialLinks } from "@/branding.config";

const ICONS = { github: Github, twitter: Twitter, linkedin: Linkedin, youtube: Youtube, discord: MessageCircle, email: Mail };

const COLS = [
  { title: "Product",
    links: [
      { to: "/pricing",    label: "Pricing" },
      { to: "/features",   label: "Features" },
      { to: "/locations",  label: "Locations" },
      { to: "/enterprise", label: "Enterprise" },
      { to: "/partners",   label: "Partners" },
      { to: "/status",     label: "Status" },
    ] },
  { title: "Company",
    links: [
      { to: "/about",   label: "About" },
      { to: "/kb",      label: "Knowledge Base" },
      { to: "/contact", label: "Contact" },
      { to: "/faq",     label: "FAQ" },
    ] },
  { title: "Legal",
    links: [
      { to: "/privacy",        label: "Privacy" },
      { to: "/terms",          label: "Terms" },
      { to: "/cookies",        label: "Cookies" },
      { to: "/acceptable-use", label: "Acceptable Use" },
      { to: "/sla",            label: "SLA" },
    ] },
];

export default function PublicFooter() {
  const socials = activeSocialLinks();

  return (
    <footer className="mt-40 relative">
      <div className="divider" />
      <div className="mx-auto max-w-7xl px-6 py-20 grid grid-cols-2 md:grid-cols-5 gap-12">
        <div className="col-span-2">
          <Logo size="lg" />
          <p className="mt-5 text-sm text-muted-foreground max-w-xs leading-relaxed">
            {BRAND.default_meta_description}
          </p>
          <div className="mt-7 flex items-center gap-2.5">
            {socials.map(({ key, url }) => {
              const Icon = ICONS[key] || Mail;
              return (
                <a
                  key={key}
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`social-${key}`}
                  aria-label={key}
                  className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-muted-foreground hover:text-foreground hover:border-primary/50 transition-colors"
                >
                  <Icon size={15} />
                </a>
              );
            })}
          </div>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground/80 font-bold">
              {c.title}
            </div>
            <ul className="mt-5 space-y-3">
              {c.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="divider" />
      <div className="mx-auto max-w-7xl px-6 h-16 flex flex-col md:flex-row items-center md:justify-between gap-2 text-xs text-muted-foreground">
        <span>{BRAND.copyright_text}</span>
        <span className="font-mono opacity-70">
          {BRAND.compliance_badges.map((b, i) => (
            <span key={b}>{i > 0 && <span className="mx-2 opacity-40">·</span>}{b}</span>
          ))}
        </span>
      </div>
    </footer>
  );
}
